if (!customElements.get("loyalty-total")) {
  customElements.define(
    "loyalty-total",
    class LoyaltyTotal extends HTMLElement {
      constructor() {
        super();
      }

      async connectedCallback() {
        this.points_el = this.querySelector(".points");
        this.initial_variant = this.dataset.initialVariantId; //used on pdp
        const isPdp = !!this.closest(".product");
        this.all_data = [];

        if (!this.points_el) {
          return;
        }

        var product_date = [];
        this.quantity_data = {};
        try {
          product_date = JSON.parse(
            this.querySelector("#loyalty-cart-data").innerText,
          );

          this.quantity_data = JSON.parse(
            this.querySelector("#loyalty-quantity-data").innerText,
          );
        } catch (error) {
          console.error(error);
          this.classList.add("hidden");
        }
        if (product_date.length == 0 || Object.keys(this.quantity_data) == 0)
          return;

        this.potentialPointCall(product_date).then((all_data) => {
          this.all_data = all_data;
          this.renderPoints(this.all_data, this.initial_variant);
        });

        if (isPdp) {
          //setup event listener for variant change
          document.body.addEventListener(
            "variantChange",
            this.handleVariantChange.bind(this),
          ); //user changes main product variant
        }
      }

      async potentialPointCall(products) {
        var promises = products.map((product) => {
          return fetch(
            "https://storefront.yotpo.com/loyalty/v3/stores/PoXGxVsm1TW57w4qSThgEdjI5WB0UHkZrJWGgUMy/product_potential_points",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(product),
            },
          )
            .then((data) => data.json())
            .then((data) => data)
            .catch((error) => {
              this.classList.add("hidden");
            });
        });

        return Promise.all(promises);
      }

      renderPoints(all_data, variant_id) {
        var sum = 0;
        for (let i = 0; i < all_data.length; i++) {
          const element = this.variantPoints(all_data[i], variant_id);

          if (!element) continue;
          sum = sum + element.points * this.quantity_data[element.id];
        }

        if (sum > 0) {
          this.points_el.innerText = sum;
        }
      }

      variantPoints(data, variant_id) {
        var variants_with_points =
          data.product_potential_points?.variants_with_points;

        if (variants_with_points.length == 1 || !variant_id) {
          //cart items just have single variant
          return variants_with_points[0];
        }

        var found = variants_with_points.find((el) => {
          return el.id == variant_id;
        });

        return found;
      }

      handleVariantChange(e) {
        var current_variant = e.detail.currentVariant;
        if (!current_variant) return;

        this.renderPoints(this.all_data, current_variant.id);
      }
    },
  );
}
